// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "-es2015." + {"30":"6595ac85d9d850ec5c5f","489":"65006d52a62542a94d7e"}[chunkId] + ".js";
};